import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../common/common";
import { useSearchParams } from "react-router-dom";

const LoginButton = () => {
  const { loginWithRedirect, error } = useAuth0();
  const [ searchParams ] = useSearchParams();
  const [ errorMessage, setErrorMessage] = useState()

  useEffect(() => {
    if(error) {
        setErrorMessage(error.message);
    } else if(searchParams.get("error_description")) {
        setErrorMessage(searchParams.get("error_description"));
    }
  }, []);

  return (
        <Box sx={{ padding: "50px", alignItems: "center", justifyContent: "flex-start", textAlign: "center" }}>
            {(errorMessage && (
                <>
                    <Typography variant="body" color="error"><b>Error</b><br/></Typography>
                    <Typography variant="body" color="error">{capitalizeFirstLetter(errorMessage)}<br/><br/></Typography>
                </>
            ))}
            
            <Typography variant='h6'>Please log in to access the Data Visualizer</Typography>
            <Button
                variant="contained"
                color="secondary"
                onClick={() => loginWithRedirect()}
            >
                Log In
            </Button>
        </Box>
    );
};

export default LoginButton;